import { useLanguage } from "@/contexts/LanguageContext";

const Experience = () => {
  const { t } = useLanguage();
  const experiences = t("experience.jobs");
  return (
    <section id="experience" className="py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">{t("experience.title")}</h2>
          <p className="text-muted-foreground text-lg">{t("experience.subtitle")}</p>
          <div className="w-20 h-1 bg-primary mx-auto mt-6" />
        </div>

        <div className="max-w-4xl mx-auto relative">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-primary/50 to-transparent" />

          {experiences.map((exp, index) => (
            <div
              key={index}
              className="relative pl-20 pb-12 animate-slide-in"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="absolute left-6 top-2 w-5 h-5 bg-primary rounded-full border-4 border-background shadow-accent" />
              
              <div className="gradient-premium p-6 rounded-lg border border-primary/20 hover:border-primary/40 transition-all hover:shadow-premium">
                <div className="text-primary font-semibold mb-2">{exp.period}</div>
                <h3 className="text-2xl font-bold mb-1">{exp.company}</h3>
                <div className="text-muted-foreground font-medium mb-4">{exp.role}</div>
                <ul className="space-y-2">
                  {exp.achievements.map((achievement, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="text-primary mt-1">▹</span>
                      <span className="text-muted-foreground">{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
